// extracted by mini-css-extract-plugin
export default {"widget":"TrustPilot_widget__WK4br"};